import { ArrayUtils } from '@colonist/utils';
import { UICornerNotificationView } from './UICornerNotificationView.ts';
import { NotificationContentType } from '../../../shared/scripts/ui_utils/NotificationUtils.ts';
export class UICornerNotificationController {
    static showNotification(icon, text, duration, action, removeAction, isPermanent, contentType = NotificationContentType.General) {
        duration = duration !== null && duration !== void 0 ? duration : this.DURATION;
        if (this.shouldEditPreviousNotification()) return this.editPreviousNotification(duration, text, isPermanent);
        return this.createNotification(icon, text, duration, action, removeAction, isPermanent, contentType);
    }
    static shouldEditPreviousNotification() {
        if (this.notifications.length == 0) return false;
        const notificationTypesToEdit = [
            NotificationContentType.Volume
        ];
        const lastNotification = this.notifications[this.notifications.length - 1];
        return notificationTypesToEdit.includes(lastNotification.notificationView.contentType);
    }
    static editPreviousNotification(duration, text, isPermanent) {
        const lastNotification = this.notifications[this.notifications.length - 1];
        clearTimeout(lastNotification.timeout);
        lastNotification.notificationView.resetTimerAnimation(duration);
        lastNotification.notificationView.updateText(text);
        if (!isPermanent) this.setNotificationTimeout(lastNotification, duration);
        return lastNotification.notificationView;
    }
    static createNotification(icon, text, duration, action, removeAction, isPermanent, contentType = NotificationContentType.General) {
        const newNotificationView = new UICornerNotificationView(icon, text, duration, action, removeAction, isPermanent, contentType);
        const newNotification = {
            notificationView: newNotificationView
        };
        this.notifications.push(newNotification);
        const newRemoveAction = ()=>{
            if (removeAction != undefined) removeAction();
            this.removeNotification(newNotification);
        };
        newNotificationView.updateRemoveAction(newRemoveAction);
        this.removeExtraNotification();
        if (!isPermanent) this.setNotificationTimeout(newNotification, duration);
        return newNotificationView;
    }
    static setNotificationTimeout(notification, duration) {
        notification.timeout = setTimeout(()=>{
            this.removeNotification(notification);
        }, duration);
    }
    static removeNotification(notification) {
        if (!ArrayUtils.removeElementFromArray(this.notifications, notification)) return;
        notification.notificationView.close();
        clearTimeout(notification.timeout);
    }
    static removeExtraNotification() {
        const nonPermanentNotifications = this.notifications.filter((notification)=>!notification.notificationView.isPermanent);
        if (nonPermanentNotifications.length <= this.MAX_NON_PERMANENT_NOTIFICATIONS) return;
        this.removeNotification(nonPermanentNotifications[0]);
    }
}
UICornerNotificationController.notifications = [];
UICornerNotificationController.DURATION = 5000;
UICornerNotificationController.MAX_NON_PERMANENT_NOTIFICATIONS = 3;
